{
  "appointment": {
    "CONFIRMATION_NUMBER": "Số xác nhận",
    "APPOINTMENT_ID": "ID cuộc hẹn",
    "APPOINTMENT_DATE": "Ngày hẹn",
    "APPOINTMENT_TIME": "Giờ hẹn",
    "APPOINTMENT_TIMEZONE": "Múi giờ",
    "APPOINTMENT_TYPE": "Loại cuộc hẹn",
    "SCHEDULED_DURATION": "Thời lượng dự kiến (phút)",
    "STATUS": "Trạng thái",
    "ARRIVAL_DATE": "Ngày đến",
    "ARRIVAL_TIME": "Giờ đến",
    "DEPARTURE_DATE": "Ngày rời đi",
    "DEPARTURE_TIME": "Giờ rời đi",
    "DWELL_TIME": "Thời gian lưu lại (phút)",
    "ON_TIME": "Độ đúng giờ (phút)",
    "IN_PROGRESS_DATE": "Ngày bắt đầu xử lý",
    "IN_PROGRESS_TIME": "Giờ bắt đầu xử lý",
    "WAIT_TIME": "Thời gian chờ (phút)",
    "PROCESSING_TIME": "Thời gian xử lý (phút)",
    "WAREHOUSE": "Kho hàng",
    "DOCK": "Cửa kho",
    "LOAD_TYPE": "Loại hàng",
    "LOAD_TYPE_DIRECTION": "Hướng",
    "RESCHEDULE_COUNT": "Số lần đổi lịch",
    "CREATED_BY": "Người tạo",
    "CREATOR_TYPE": "Loại người tạo",
    "CREATION_DATE": "Ngày tạo",
    "LAST_UPDATED_BY": "Người cập nhật cuối",
    "LAST_UPDATE_DATE": "Ngày cập nhật cuối",
    "LAST_UPDATE_TIME": "Giờ cập nhật cuối",
    "CARRIER_COMPANY": "Công ty vận chuyển",
    "CONTACT_NAME": "Tên liên hệ",
    "CONTACT_EMAIL": "Email liên hệ",
    "CONTACT_PHONE": "Điện thoại liên hệ",
    "NOTES": "Ghi chú",
    "TAGS": "Thẻ",
    "CUSTOM_FIELDS": "Trường tùy chỉnh",
    "EXTERNAL_VALIDATION_STATUS": "Trạng thái xác thực bên ngoài",
    "EXTERNAL_VALIDATION_ERROR_MESSAGE": "Thông báo lỗi xác thực bên ngoài",
    "CheckOut": "Check-out",
    "CheckInAdditionalAssetDetails": "Chi tiết tài sản bổ sung khi check-in",
    "InboundClaim": "Khiếu nại nhập hàng",
    "OutboundClaim": "Khiếu nại xuất hàng",
    "BookLoadType": "Loại hàng khi đặt lịch",
    "AssetContainerDetails": "Chi tiết container tài sản",
    "AppointmentCompleted": "Cuộc hẹn đã hoàn tất"
  },
  "assetVisit": {
    "id": "ID lượt ghé",
    "appointmentId": "ID cuộc hẹn",
    "checkInDate": "Ngày/giờ check-in",
    "checkOutDate": "Ngày/giờ check-out",
    "carrier": "Hãng vận chuyển",
    "warehouseName": "Kho hàng",
    "currentStatus": "Trạng thái",
    "licensePlate": "Biển số xe",
    "visitType": "Loại lượt ghé",
    "dotNumber": "Số DOT",
    "phone": "Điện thoại",
    "isPlanned": "Có kế hoạch",
    "driverNotes": "Ghi chú của tài xế",
    "checkInAcknowledged": "Đã xác nhận check-in",
    "firstName": "Tên (xác minh danh tính)",
    "lastName": "Họ (xác minh danh tính)",
    "birthdate": "Ngày sinh (xác minh danh tính)",
    "idValidationEmail": "Email (xác minh danh tính)",
    "idValidationPhone": "Điện thoại (xác minh danh tính)"
  }
}
